module.exports = __webpack_public_path__ + "static/media/crowfinance.e3898a5d.png";